import { isDate, isNil, isString } from 'lodash';
import { DateTime, Duration, DurationUnit } from 'luxon';
import { AbstractControl } from '@angular/forms';
import { IDatiqRateDateRange } from '@dat/datiq-core/models';

export function isControlValueARange(control: AbstractControl): boolean {
    return (
        !!control?.value && !isDate(control?.value) && !isString(control?.value)
    );
}

export function isDateInvalidMax(
    date: string | Date,
    compareDate: string | Date
): boolean {
    return getDateTime(compareDate) > getDateTime(date);
}

export function isDateInvalidMin(
    date: string | Date,
    compareDate: string | Date
): boolean {
    return getDateTime(compareDate) < getDateTime(date);
}

export function isDateInvalidRange(dateRange: IDatiqRateDateRange): boolean {
    return (
        isNil(dateRange?.start) ||
        isNil(dateRange?.end) ||
        (isDateInvalidMin(dateRange?.start, dateRange?.end) &&
            isDateInvalidMax(dateRange?.end, dateRange?.start))
    );
}

export function diffBetweenDates(
    startDate: Date | string,
    endDate: Date | string,
    unit: DurationUnit
): number {
    return Math.abs(
        getDateTime(endDate).diff(getDateTime(startDate), unit)[unit]
    );
}

export function getDateTime(date: Date | string): DateTime {
    return typeof date === 'string'
        ? DateTime.fromISO(date)
        : DateTime.fromJSDate(date);
}
